module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi9-7f912ecd84c1ec4d83271ae84854b46c.jpg";